<script setup lang="ts">
import { usePortfolio } from '../../../utilities/portfolio/usePortfolio'
import PortfolioSummary from '../portfolio/PortfolioSummary.vue'
import PortfolioPreEmptiveRights from './PortfolioPreEmptiveRights.vue'
import PortfolioWallet from '../portfolio/PortfolioWallet.vue'
import PortfolioOpenInvestments from '../portfolio/PortfolioOpenInvestments.vue'
import PortfolioMyInvestments from '../portfolio/PortfolioMyInvestments.vue'
import { useWalletState } from '../../../utilities/account/useWallet'

const { state: portfolioState } = usePortfolio()

const walletState = useWalletState()
</script>

<template>
    <div class>
        <PortfolioSummary
            :orders-per-issuer="portfolioState.ordersPerIssuerAccepted"
            :loading="portfolioState.ordersPerIssuerAcceptedLoading" />
        <PortfolioPreEmptiveRights />
        <PortfolioWallet :wallet="walletState.wallet" />
        <PortfolioOpenInvestments
            :orders="portfolioState.openInvestments"
            :loading="portfolioState.openInvestmentsLoading" />
        <PortfolioMyInvestments
            :orders-per-issuer-active="portfolioState.ordersPerIssuerActiveItems"
            :orders-per-issuer-completed="portfolioState.ordersPerIssuerCompletedItems"
            :loading="
                portfolioState.ordersPerIssuerActiveItemsLoading || portfolioState.ordersPerIssuerCompletedItemsLoading
            " />
    </div>
</template>
